import apiClient from "@/clients/apiClient";
import type { GenContenidoNosotrosPayload } from "../interfaces/genContenidoNosotros.interface";

type ApiEnvelope<T> = { data: T; message: string; status: number };

export async function getGenContenidoNosotrosAction(): Promise<GenContenidoNosotrosPayload> {
  const res =
    await apiClient.get<ApiEnvelope<GenContenidoNosotrosPayload>>(
      "genContenidoNosotros"
    );
  return res.data.data;
}
